import { useMutation } from "react-query";
import { axiosInstance } from "../../config/axios";

export const useEnrollMerchantBankWithExcel = () => {
    return useMutation(async (formData: FormData) => {
        const response = await axiosInstance.post(
            "/MerchantSoftPOSEnrollment/EnrollMerchantBankWithExcel",
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
        return response.data;
    });
};